<script>
    import Item from './item.svelte';

    export let items = [];
</script>

<style>
    .archive-list:not(._empty) {
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
    }

    :global(.archive-list .item) {
        margin-right: 10px;
        margin-bottom: 10px;
    }
</style>

<div class="archive-list" class:_empty={!items.length}>
    {#each items as item}
        <Item {item} />
    {:else}
        <article class="message is-info">
            <div class="message-body">
                V tomto seznamu nejsou žádné lekce.
            </div>
        </article>
    {/each}
</div>
